module.exports = __webpack_public_path__ + "static/media/firework image.1b96b8fe.svg";